import { grid, maxWidthContainer, minBreakpoints, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  spacing = theme.spacing,
  text = theme.text;
var bannerHeadingSizes = {
  XXS: text.HEADING.SM,
  L: text.HEADING.LG
};
export var container = /*#__PURE__*/css(["", " ", " grid-row-gap:0;"], grid, maxWidthContainer);
export var bottomOffsetImageMarginContainer = /*#__PURE__*/css(["padding-top:", ";", ";"], pxToRem(spacing.lg), mediaQuery({
  min: minBreakpoints.L
}, css(["padding-top:", ";"], pxToRem(spacing.xl))));
export var imageWrapper = /*#__PURE__*/css(["grid-column:span 12;", ";", ";"], mediaQuery({
  min: minBreakpoints.M
}, css(["grid-column:span 6;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:2 / span 5;"])));
export var content = /*#__PURE__*/css(["margin:-", " 0 ", ";grid-column:span 12;*{color:var(--neutral-black-base);}", ";", ";", ";"], pxToRem(spacing.sm), pxToRem(spacing.base), mediaQuery({
  min: minBreakpoints.M
}, css(["grid-column:span 6;margin:0;"])), mediaQuery({
  min: minBreakpoints.L
}, css(["grid-column:8 / span 5;margin:", " 0;"], pxToRem(spacing.sm))), mediaQuery({
  min: minBreakpoints.XL
}, css(["grid-column:8 / span 4;"])));
export var copy = /*#__PURE__*/css(["display:block;margin:", " 0;"], pxToRem(spacing.lg));
export var heading = /*#__PURE__*/css(["", " ", ""], copy, responsiveFontSize(bannerHeadingSizes));
export var cta = /*#__PURE__*/css(["", ";font-family:", ";font-weight:", ";"], copy, fonts.PRIMARY_SEMIBOLD.family, fonts.PRIMARY_SEMIBOLD.weight);